import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  noindex?: boolean;
}

const SEO = ({
  title = "Vespid - Gamified Financial Literacy Education Malaysia",
  description = "Learn personal finance with Vespid, Malaysia's leading gamified financial literacy education platform. Master budgeting, investing, and money management through interactive lessons.",
  keywords = "financial literacy Malaysia, personal finance education, budgeting app Malaysia, financial learning platform, money management education, financial literacy app, investment education Malaysia",
  image = "/vespidLogo.png",
  url = "https://vespid.my/",
  type = "website",
  noindex = false
}: SEOProps) => {
  const baseUrl = "https://vespid.my";
  const fullUrl = url.startsWith('http') ? url : `${baseUrl}${url}`;
  const fullImageUrl = image.startsWith('http') ? image : `${baseUrl}${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />
      
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Vespid" />
      <meta property="og:locale" content="en_MY" />
      
      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
      <meta name="twitter:url" content={fullUrl} />
      
      {/* Additional SEO Tags */}
      <meta name="author" content="Vespid" />
      <meta name="publisher" content="Vespid" />
      <meta name="language" content="English" />
      <meta name="coverage" content="Malaysia" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />
    </Helmet>
  );
};

export default SEO;